module.exports = {
    FAVORITE_CHANNEL_ADD: 'FAVORITE_CHANNEL_ADD',
    FAVORITE_CHANNEL_DEL: 'FAVORITE_CHANNEL_DEL',
    FAVORITE_CHANNELS_SAVE: 'FAVORITE_CHANNELS_SAVE',
    FAVORITE_CHANNELS_UPDATE: 'FAVORITE_CHANNELS_UPDATE',
};
